import { useIntl } from 'react-intl';

import { EntityPacingStatus } from '../EntityPacingStatus';

import type { CampaignPlanPacingProgress } from 'sonata-static-storage/lib/common/common.types';
import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';

type Props = {
  currencyInfo: BaseCurrencyInterface;
  entityPacing: CampaignPlanPacingProgress | null;
};

export function CampaignPlanPacingStatus({ currencyInfo, entityPacing }: Props) {
  const { formatMessage } = useIntl();

  const insertionOrdersPacing =
    entityPacing?.insertionOrders?.map(({ insertionOrderId: id, ...ioEntry }) => ({
      ...ioEntry,
      id
    })) || [];

  return (
    <EntityPacingStatus
      currencyInfo={currencyInfo}
      entityPacing={
        entityPacing
          ? {
              ...entityPacing,
              childrenPacingStatus: insertionOrdersPacing,
              id: entityPacing.campaignPlanId,
              name: formatMessage({
                defaultMessage: 'Budget',
                id: 'pacingStatusModal.content.campaignPlanTable.totalRowTitle'
              }),
              type: 'campaignPlan'
            }
          : { id: '', isComposed: true, pacings: [], type: 'campaignPlan' }
      }
      headerName={formatMessage({
        defaultMessage: 'IO Name',
        id: 'pacingStatusModal.content.campaignPlanTable.headerName'
      })}
      includeDatesColumn
      isTopLevel
      title={formatMessage({
        defaultMessage: 'Campaign Plan',
        id: 'pacingStatusModal.content.campaignPlanTable.title'
      })}
    />
  );
}
